import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import { useMemo } from "react";
import BaseScoringChart from "./BaseScoringChart";

HighchartsMore(Highcharts);

export default function RadarChart({ series, categories, isLoading = false, option, ...props }) {
  const options = useMemo(() => {
    return Highcharts.merge(
      {
        chart: {
          polar: true,
          type: "area",
        },
        title: {
          text: undefined,
        },
        pane: {
          startAngle: -22.5,
          endAngle: 337.5,
        },
        xAxis: {
          tickmarkPlacement: "on",
          lineWidth: 0,
          categories: categories,
        },
        yAxis: {
          gridLineInterpolation: "polygon",
          lineWidth: 0,
          min: 0,
          max: 1000,
          tickInterval: 500,
        },
        legend: {
          layout: "vertical",
        },
        series: series,
        tooltip: {
          enabled: true,
          shared: true,
        },
      },
      option
    );
  }, [series, option, categories]);

  return <BaseScoringChart isLoading={isLoading} highcharts={Highcharts} options={options} {...props} />;
}
